/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.toolhealth.ToolHealthClassification
*/
export var ToolHealthClassification;
(function (ToolHealthClassification) {
    ToolHealthClassification["TECHNICALLY_BROKEN"] = "TECHNICALLY_BROKEN";
    ToolHealthClassification["USER_SPECIFIC_TECHNICAL"] = "USER_SPECIFIC_TECHNICAL";
    ToolHealthClassification["USER_PERMISSION"] = "USER_PERMISSION";
    ToolHealthClassification["USER_INPUT"] = "USER_INPUT";
    ToolHealthClassification["INTERMITTENT"] = "INTERMITTENT";
    ToolHealthClassification["WORKING"] = "WORKING";
    ToolHealthClassification["UNCLEAR"] = "UNCLEAR";
})(ToolHealthClassification || (ToolHealthClassification = {}));
//# sourceMappingURL=ToolHealthClassification.js.map